import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DrawerComponent from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Drawer';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import ModalForm from 'Views/Page/Content/Modal/Components/ModalForm';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import classNames from 'classnames';
import { DataValueMap } from 'Helpers/Testing';

const useStyles = buildUseStyles('Template', ((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  paper: {
    width: theme.dimensions.lg,
    padding: theme.spacing(2),
  },
  anchorTopBottom: {
    width: 'unset',
  },
})));

const Drawer = ({
  Layout,
  metaOverrideSet,
  variant,
  anchor,
  test,
}) => {
  const classes = useStyles();
  const isAnchorTopBottom = anchor === 'top' || anchor === 'bottom';

  const {
    modalCollection,
    clearModalCollection,
    actionsRef,
    titleRef,
  } = useModalContext();

  return (
    <DrawerComponent
      anchor={anchor}
      variant={variant}
      onClose={() => {
        clearModalCollection();
      }}
      open={!!modalCollection}
      test={test}
      PaperProps={{ className: classNames(classes.paper, { [classes.anchorTopBottom]: isAnchorTopBottom }) }}
    >
      <div
        className={classes.header}
      >
        <IconButton
          onClick={() => {
            clearModalCollection();
          }}
          color={'inherit'}
          icon={CloseIcon}
          title={'Close'}
          {...DataValueMap.init('drawer-close').build()}
        />
      </div>
      <div className={classes.title} ref={titleRef} />
      <ModalForm
        Layout={Layout}
        metaOverrideSet={metaOverrideSet}
      />
      <div className={classes.actions} ref={actionsRef} />
    </DrawerComponent>
  );
};

Drawer.defaultProps = {
  variant: 'temporary',
  anchor: 'right',
};

Drawer.propTypes = {
  Layout: PropTypes.object.isRequired,
  metaOverrideSet: PropTypes.object.isRequired,
  variant: PropTypes.string,
  anchor: PropTypes.string,
  test: PropTypes.string.isRequired,
};

export default Drawer;
